'use client'

import { Box, Flex } from '@mantine/core'
import React from 'react'

import MaskIcon from '@/assets/icons/mask_group.svg'
import ArrowIcon from '@/assets/icons/polygon.svg'

import classes from './style.module.css'

const START_ANGLE = -90
const END_ANGLE = 90
const INNER_RADIUS = 4

//the mask is not 100 percent 180 degrees, so we need to offset the radius a bit
const RADIUS_OFFSET = -4

const clamp = (v: number, min: number, max: number) => Math.min(max, Math.max(min, v))
const degToRad = (deg: number) => (deg * Math.PI) / 180

export default function FearGreedClient({ value }: { value: number }) {
  const v = clamp(value, 0, 100)
  const rotation = START_ANGLE + (v / 100) * (END_ANGLE - START_ANGLE) + RADIUS_OFFSET

  const theta = degToRad(rotation)
  const dx = INNER_RADIUS * Math.sin(theta)
  const dy = -INNER_RADIUS * Math.cos(theta)

  return (
    <Box className={classes.fearGreedContainer}>
      <Box className={classes.gaugeWrapper}>
        <MaskIcon className={classes.maskIcon} />
        <ArrowIcon
          className={classes.arrowIcon}
          style={{
            transform: `translate(-50%, -100%) translate(${dx}px, ${dy}px) rotate(${rotation}deg)`,
          }}
        />
        <Flex mih={20} align="center" className={classes.label}>
          {v}
        </Flex>
      </Box>
    </Box>
  )
}
